/* TODO: translate */

import { Labels } from '../../shared-components/global/labels';

Labels.set(
    'ui-autocomplete',
    'hint',
    'Liigu nooleklahvidega üles ja alla, et vaadata, ning Enter-klahvi, et valida.'
);
Labels.set('ui-autocomplete', 'suggestions', 'Soovitused');
Labels.set('ui-autocomplete', 'suggestionsFound', 'Soovitusi näidatakse: ');
Labels.set('ui-autocomplete', 'noSuggestionsFound', 'Soovitusi ei näidata');
